export default __webpack_public_path__ + "static/15-50f679ef1349c51f7352d31f504d6102.webp";